const UsersRoutes = {
  getAllUsers: "/user"
}

export default UsersRoutes